import { useMemo } from 'react';

import {
  ADMIN_ROLE,
  CLIENT_ROLE,
  GUEST_ROLE,
  RECRUITER_ROLE,
} from '@/constants/roles';
import { useAppSelector } from '@/store/hooks';

export type CurrentUserRoleFlags = {
  isAdmin: boolean;
  isClient: boolean;
  isRecruiter: boolean;
  isGuest: boolean;
};

export function roleFlagsFromRole(
  role: string | undefined,
): CurrentUserRoleFlags {
  return {
    isAdmin: role === ADMIN_ROLE,
    isClient: role === CLIENT_ROLE,
    isRecruiter: role === RECRUITER_ROLE,
    isGuest: role === GUEST_ROLE,
  };
}

export function useCurrentUser() {
  const user = useAppSelector((state) => state.user.user);
  const isAuth = useAppSelector((state) => state.user.isAuth);
  const loading = useAppSelector((state) => state.user.loading);
  const sessionToken = useAppSelector((state) => state.user.sessionToken);

  return useMemo(() => {
    const role = user?.role;

    return {
      user: user,
      isAuth,
      loading,
      sessionToken,
      isAdmin: role === ADMIN_ROLE,
      isClient: role === CLIENT_ROLE,
      isRecruiter: role === RECRUITER_ROLE,
      isGuest: role === GUEST_ROLE,
    };
  }, [user, isAuth, loading, sessionToken]);
}
